import { render, staticRenderFns } from "./mail_content.vue?vue&type=template&id=e703e5e0&scoped=true"
import script from "./mail_content.vue?vue&type=script&lang=js"
export * from "./mail_content.vue?vue&type=script&lang=js"
import style0 from "./mail_content.vue?vue&type=style&index=0&id=e703e5e0&prod&scoped=true&lang=less"
import style1 from "./mail_content.vue?vue&type=style&index=1&id=e703e5e0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e703e5e0",
  null
  
)

export default component.exports